import { db } from "utils/firebaseConfig";

const deletePost = (
  collection,
  postId,
  goodsReviewList,
  setGoodsReviewList
) => {
  let DeleteAfterArr = [];

  db.collection(collection)
    .doc(postId)
    .delete()
    .then(() => {
      console.log("삭제성공");

      DeleteAfterArr = goodsReviewList.filter(
        (review) => review.postid !== postId
      );

      setGoodsReviewList(DeleteAfterArr);
    })
    .catch((error) => {
      console.error("에러: ", error);
    });
};

export default deletePost;
